<div class="modal-dialog" role="document">
	<div class="modal-content">
		<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
			<button class="btn btn-default-reverse btn-block btn-sm"
				[attr.data-dismiss]="'modal'" type="button" (click)="close($event);">Chiudi</button>
		</p>
		<div class="col-sm-12 coldx">
			<h4>Correla pratiche</h4>

			<form class="cerca_grey">
				<div class="row" #searchPratiche
					searchPraticheInput [correlateResearch]="true"
					[soloPratiche]="false" [ordineAscendente]="true"
					[idPraticaBase]="pratica?.id" (onReturn)="refresh($event)"
					(onReload)="refresh($event, true)"></div>
			</form>
			<div class="container_dati_generali container_overflow"
				*ngIf="pratiche?.length > 0">
				<ul  class="pratiche" [ngClass]="tipoPratica">
					<li class="panel" *ngFor="let pratica of pratiche; let i = index">
						<div class="{{'pratica ' +  getTipoPratica(pratica)}}">
							<div>
								<p [className]="'categoria '+ getTipoPratica(pratica)">{{pratica.intestazione.campi.tipoPratica | tipoPraticaPipe}}</p>
								<p class="codice">{{pratica.intestazione.campi.posizionePratica}}</p>
							</div>
							<div class="data_opzioni blocco_pratica">
								<div style="margin-left: 0; width: 22px;"  singleCheckBoxModInput [labelInput]="''"
									[showLabel]="false" idInput="selected"
									[objectReference]="pratica?.selected"
									(onReturn)="pratica.selected = $event"></div>
							</div>
							<div>
							<p class="identificativo">
									{{pratica.intestazione.campi.societa ?
									pratica.intestazione.campi.societa + ' -
									':''}}{{pratica.intestazione.campi.dataAperturaPratica |
									date:'d/M/y'}} &nbsp; <span *ngIf="pratica.definito" title="Definita"
										class="glyphicon glyphicon-lock"></span> <span
										*ngIf="pratica.correlata" title="Correlata"
										class="glyphicon glyphicon-link"></span> <span
										*ngIf="pratica.capofila" title="Capofila riunione di giudizi"
										class="riunionegiudizi glyphicon glyphicon-resize-small"><span
										class="glyphicon capofila">C</span></span> <span *ngIf="pratica.riunita"
										title="Riunione di giudizi" class="glyphicon glyphicon-resize-small"></span>
									<span *ngIf="pratica.archiviata" title="Archiviata"
										class="glyphicon glyphicon-floppy-saved"></span>
										<a *ngIf="pratica.fascicoliLight && pratica.fascicoliLight.length > 0" style="margin-right: 0px; margin-top: 25px;"
											data-toggle="collapse" [attr.aria-controls]="'subpratica'+pratica.id"
											href="{{'#subpratica'+pratica.id}}" aria-expanded="false"
											class="collapsed"><span>Apri</span></a>
								</p>
								<h4 class="titolo" style="max-width: calc(100% - 245px)">
									<a (click)="close();"
										[routerLink]="['/pratica/',getPraticaPathFromType(pratica), getPraticaViewPath(), pratica.id]">
										{{pratica.intestazione.campi.contropartePrimaria ?
										pratica.intestazione.campi.contropartePrimaria + " - " :
										"Nessun soggetto/parte specificato " + " - " }} {{
										pratica.intestazione.campi.materia ?
										pratica.intestazione.campi.materia + "/" : ""}} {{
										pratica.intestazione.campi.oggetto ?
										pratica.intestazione.campi.oggetto : "" }} </a>
								</h4>
								<p *ngIf="pratica.intestazione.campi.testoDiEvidenza"
									class="descrizione">{{pratica.intestazione.campi.testoDiEvidenza}}</p>
							</div>
						</div>
						<ul class="collapse" id="subpratica{{pratica.id}}"
										*ngIf="pratica.fascicoliLight && pratica.fascicoliLight.length > 0">
										<li *ngFor="let fascicolo of pratica.fascicoliLight | orderBy:'intestazione.campi.posizione:DESC'; let j = index">
											<div
												class="{{'subpratica ' + (getCssClassCategoriaFascicolo(fascicolo)) + (!fascicolo.visible ? ' disabled' : '') }}">
												<div>
													<p class="{{'categoria ' + fascicolo?.intestazione.campi.tipoFascicolo.toLowerCase()}}">
													{{ fascicolo?.intestazione.campi.tipoFascicolo}}</p>
													<p class="codice">{{ fascicolo?.intestazione.campi.posizione}}</p>
												</div>
												<div>
													<p class="identificativo">
														{{fascicolo?.intestazione.campi.numeroRuolo ? 'N. ruolo' :''}}
														<strong>{{fascicolo?.intestazione.campi.numeroRuolo ?	fascicolo?.intestazione.campi.numeroRuolo+' ' :''}} </strong>
														{{fascicolo?.intestazione.campi.annoRuolo && fascicolo?.intestazione.campi.numeroRuolo ? '-' :''}}
														{{fascicolo?.intestazione.campi.annoRuolo ? 'A. ruolo' :''}}
														<strong>{{fascicolo?.intestazione.campi.annoRuolo ?	fascicolo?.intestazione.campi.annoRuolo+' ' :' '}} </strong>
														{{ fascicolo?.intestazione.campi.annoRuolo || fascicolo?.intestazione.campi.numeroRuolo ? '&nbsp;' : '' }}
														{{ 'DEL ' + (fascicolo.intestazione.campi.dataInizioFascicolo |
														date:'dd/MM/yyyy') }}
														{{ fascicolo.intestazione.campi.definito ?
														' - DEFINITA IL ' +
														(fascicolo.intestazione.campi.dataDefinizione |
														date:'dd/MM/yyyy') : '' }}
														{{(fascicolo.intestazione.campi.tipoRicorso) ? (' - '+fascicolo.intestazione.campi.tipoRicorso) : ''}}
														{{(fascicolo.intestazione.campi.tipoOpposizione) ? (' - '+fascicolo.intestazione.campi.tipoOpposizione) : ''}}
														<span
															*ngIf="fascicolo.intestazione.campi.definito" title="Definito"
															class="glyphicon glyphicon-lock"></span> <span
															*ngIf="fascicolo.intestazione.campi.capofila"
															title="Capofila riunione di giudizi"
															class="riunionegiudizi glyphicon glyphicon-resize-small"><span
															class="glyphicon capofila">C</span></span> <span
															*ngIf="fascicolo.intestazione.campi.riunito"
															title="Riunione di giudizi"
															class="glyphicon glyphicon-resize-small"></span> <span
															*ngIf="pratica.archiviata" title="Archiviato"
															class="glyphicon glyphicon-floppy-saved"></span>
															<span *ngIf="fascicolo.intestazione.campi.isDocumentazione" class="glyphicon glyphicon-file" title="Documenti allegati"></span>
													</p>

													<h5 class="titolo">
														<a *ngIf="fascicolo.visible"
															[routerLink]="['/' + getRoutingPath(fascicolo, pratica),fascicolo.id]">
															{{fascicolo.intestazione.campi.contropartePrimaria ?
															fascicolo.intestazione.campi.contropartePrimaria  :
															"Nessun soggetto/parte specificato " }}
															<ng-container> {{
																fascicolo.intestazione.campi.grado ?
																   " - " + fascicolo.intestazione.campi.grado : "" }}
															</ng-container>
															{{fascicolo?.intestazione.campi.natura ? " - " +
															fascicolo?.intestazione.campi.natura : ""}}
														</a>
														<span
															*ngIf="!fascicolo.visible">
															{{fascicolo.intestazione.campi.contropartePrimaria ?
															fascicolo.intestazione.campi.contropartePrimaria :
															"Nessun soggetto/parte specificato " }}
															<ng-container> {{
																fascicolo.intestazione.campi.grado ?
																   " - " + fascicolo.intestazione.campi.grado : "" }}
															</ng-container>
															{{fascicolo?.intestazione.campi.natura ? " - " +
															fascicolo?.intestazione.campi.natura : ""}}
														</span>
													</h5>
												</div>
											</div>
										</li>
									</ul>

					</li>
				</ul>
				<div class="row"
					*ngIf="searchResponse?.numeroPraticheTotali > pratiche.length">
					<p class="allinea_centro col-sm-12">
						<a href="javascript:void(0);" (click)="reloadSearch()"> <strong>Carica
								altri risultati</strong></a>
					</p>
				</div>
			</div>
			<div class="row" *ngIf="pratiche?.length > 0">
				<p class="col-sm-3 col-xs-6">
					<button type="button" class="btn btn-outline-secondary btn-block"
						(click)="reset();">Reset</button>
				</p>
				<!-- 				<ng-template [ngIf]="afterViewInit"> -->
				<p submitButton (click)="correlaPratiche()"
					class="col-sm-3 col-xs-6 col-sm-offset-6"
					[labelButton]="'Correla pratiche selezionate'"></p>
				<!-- 				</ng-template> -->
			</div>
		</div>

	</div>
</div>


<!-- <div class="modal-dialog" [attr.role]="'document'"> -->
<!-- 	<div class="modal-content"> -->
<!-- 		<p class="col-sm-2 col-sm-offset-10"> -->
<!-- 			<button class="btn btn-default-reverse btn-block btn-sm" -->
<!-- 				[attr.data-dismiss]="'modal'" type="button" (click)="createForm();">Chiudi</button> -->
<!-- 		</p> -->
<!-- 		<div class="col-sm-12 coldx"> -->
<!-- 			<h4>Correla pratiche</h4> -->
<!-- 			<form class="cerca_grey"> -->
<!-- 				<div class="col-sm-12" searchPraticheInput (onReturn)="refresh($event)"></div> -->
<!-- 			</form> -->
<!-- 			<div class="container_dati_generali container_overflow"> -->
<!-- 				<ul class="pratiche" [ngClass]="tipoPratica"> -->
<!-- 					<li *ngFor="let pratica of pratiche; let i = index" class="panel"> -->
<!-- 						<div class="col-sm-11 pratica" [ngClass]="tipoPratica"> -->
<!-- 							<div> -->
<!-- 								<p class="categoria" [ngClass]="tipoPratica">{{pratica.intestazione.campi.tipoPratica}}</p> -->
<!-- 								<p class="codice">{{pratica.intestazione.campi.posizionePratica}}</p> -->
<!-- 							</div> -->
<!-- 							<div> -->
<!-- 								<p class="identificativo"> -->
<!-- 									{{pratica.intestazione.campi.soggetto + ' - ' }} {{ -->
<!-- 									pratica.intestazione.campi.dataApertura | date:'dd/MM/yyyy' }} -->
<!-- 									{{ pratica.intestazione.campi.definita ? 'DEFINITA IL' + -->
<!-- 									(pratica.intestazione.campi.dataDefinizione | -->
<!-- 									date:'dd/MM/yyyy') : '' }}</p> -->
<!-- 								<h4 class="titolo"> -->
<!-- 									<a [routerLink]="['/pratica', tipoPratica, pratica.id]">{{pratica.intestazione.campi.contropartePrimaria -->
<!-- 										? pratica.intestazione.campi.contropartePrimaria + " - " : "" -->
<!-- 										}} {{ pratica.intestazione.campi.materia ? -->
<!-- 										pratica.intestazione.campi.materia + "-" : ""}} {{ -->
<!-- 										pratica.intestazione.campi.oggetto ? -->
<!-- 										pratica.intestazione.campi.oggetto : "" }}</a> -->
<!-- 								</h4> -->
<!-- 							</div> -->
<!-- 						</div> -->
<!-- 						<p class="col-sm-1 singlecheckbox"> -->
<!-- 							<label class="fakelabel">Seleziona</label> <input -->
<!-- 								name="selcorrela1" id="selcorrela1" checked="" value="value1" -->
<!-- 								type="checkbox"> <label for="selcorrela1"></label> -->
<!-- 						</p> -->
<!-- 					</li> -->
<!-- 				</ul> -->
<!-- 			</div> -->
<!-- 			<div class="row"> -->
<!-- 				<div textAreaInput class="form-group col-xs-12 col-sm-12" -->
<!-- 					[labelInput]="'Motivo correlazione'" -->
<!-- 					[(ngModel)]="motivoCorrelazione"></div> -->
<!-- 			</div> -->
<!-- 			<div class="row"> -->
<!-- 				<p class="col-sm-3 col-xs-3"> -->
<!-- 					<button type="button" class="btn btn-outline-secondary btn-block" -->
<!-- 						(click)="createForm();">Reset</button> -->
<!-- 				</p> -->
<!-- 				<p class="col-sm-3 col-xs-6 col-sm-offset-6"> -->
<!-- 					<button type="button" class="btn btn-outline-secondary btn-block" -->
<!-- 						(click)="correlaPratiche()">Correla pratiche selezionate</button> -->
<!-- 				</p> -->
<!-- 			</div> -->

<!-- 		</div> -->

<!-- 	</div> -->
<!-- </div> -->
